import { lazy, Suspense } from "react";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";

const FishCategories = lazy(() => import("@/components/home/FishCategories").then(m => ({ default: m.FishCategories })));
const FeaturedProducts = lazy(() => import("@/components/home/FeaturedProducts").then(m => ({ default: m.FeaturedProducts })));
const CategorySection = lazy(() => import("@/components/home/CategorySection").then(m => ({ default: m.CategorySection })));
const ServicesPreview = lazy(() => import("@/components/home/ServicesPreview").then(m => ({ default: m.ServicesPreview })));
const B2BSection = lazy(() => import("@/components/home/B2BSection").then(m => ({ default: m.B2BSection })));
const MoreToLove = lazy(() => import("@/components/home/MoreToLove").then(m => ({ default: m.MoreToLove })));
const CTASection = lazy(() => import("@/components/home/CTASection").then(m => ({ default: m.CTASection })));
const PopupBanner = lazy(() => import("@/components/home/PopupBanner").then(m => ({ default: m.PopupBanner })));

const Index = () => {
  return (
    <Layout>
      <Suspense fallback={null}>
        <PopupBanner />
      </Suspense>
      <HeroSection />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <FishCategories />
        <FeaturedProducts />
        <CategorySection />
        <ServicesPreview />
        <B2BSection />
        <MoreToLove />
        <CTASection />
      </Suspense>
    </Layout>
  );
};

export default Index;
